export var DocsComponentName = /*#__PURE__*/function (DocsComponentName) {
  DocsComponentName["CONTACT_SELECTOR"] = "docs-component-contact-selector";
  DocsComponentName["CONTACT_SELECTOR_MOBILE"] = "docs-component-contact-selector-mobile";
  DocsComponentName["DOC_SIZE"] = "docs-component-doc-size";
  DocsComponentName["FRIEND_SELECTOR"] = "docs-friend-selector";
  DocsComponentName["MEMBER_BUTTON"] = "docs-component-member-btn";
  DocsComponentName["EXIT_DOCUMENT"] = "docs-component-exit-document";
  DocsComponentName["PRIVATIZED_ADD_MEMBER"] = "docs-component-privatized-add-members";
  DocsComponentName["PRIVATIZED_PERMISSION"] = "docs-component-privatized-permission";
  DocsComponentName["PRIVATIZED_TRANSFER"] = "docs-component-privatized-transfer";
  DocsComponentName["SHARE_PRIVATE"] = "docs-component-share-private";
  DocsComponentName["FORM_FILL_MANAGEMENT"] = "docs-component-form-fill-management";
  DocsComponentName["SAFE_FOLDER"] = "docs-component-safe-folder";
  DocsComponentName["SAFE_FOLDER_MOBILE"] = "docs-component-safe-folder-mobile";
  DocsComponentName["SHOW_TIPS"] = "docs-component-show-tips";
  DocsComponentName["COOPERATION"] = "docs-component-collaborative-management";
  DocsComponentName["COOPERATION_MOBILE"] = "docs-component-collaborative-management-mobile";
  return DocsComponentName;
}({});